export type CommonResourceKey =
  | 'common.fastIsPossible'
  | 'common.logout'
  | 'common.login'
  | 'common.submit'
  | 'common.email'
  | 'common.next'
  | 'common.previous'
  | 'common.register'
  | 'common.forgotPassword'
  | 'common.sso'
  | 'common.true'
  | 'common.false'
  | 'common.delete';

export const commonResources: Record<CommonResourceKey, string> = {
  'common.fastIsPossible': 'Fast is possible',
  'common.logout': 'Logout',
  'common.login': 'Login',
  'common.submit': 'Submit',
  'common.email': 'Email',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.register': 'Register',
  'common.forgotPassword': 'Forgot Password',
  'common.sso': 'Single Sign-On',
  'common.true': 'True',
  'common.false': 'False',
  'common.delete': 'Delete',
};
